module.exports = "<uib-alert type={{alert.type}} close=alert.hide() ng-repeat=\"alert in ktAlertContainer.alerts\">{{alert.msg}}</uib-alert>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/message-alert/alert-container.html
// module id = 557
// module chunks = 0